import React from 'react';
import {runInAction} from 'mobx';
import {observer} from 'mobx-react';
import s from '../../s';

function remainingCharactersLabel(value: string | null | undefined, max: number): string {
    const remaining = Math.max(0, max - (value ?? '').length);
    return remaining === 1 ? '1 character remaining' : `${remaining} characters remaining`;
}

const CustomFieldsComponent: React.FC = observer(() => {
    const max1 = s.prod.cf_1_max || 255;
    const max2 = s.prod.cf_2_max || 255;
    const max3 = s.prod.cf_3_max || 255;

    const save1 = (e: React.ChangeEvent<HTMLInputElement>) => {
        runInAction(() => {
            s.ps.custom_text_1 = e.target.value.truncate(max1, false);
        });
    };

    const save2 = (e: React.ChangeEvent<HTMLInputElement>) => {
        runInAction(() => {
            s.ps.custom_text_2 = e.target.value.truncate(max2, false);
        });
    };

    const save3 = (e: React.ChangeEvent<HTMLInputElement>) => {
        runInAction(() => {
            s.ps.custom_text_3 = e.target.value.truncate(max3, false);
        });
    };

    if (!s.ready || !s.ui.show_cust || s.prod.IsCAF) {
        return null;
    }

    const text1 = s.ps.custom_text_1 ?? '';
    const text2 = s.ps.custom_text_2 ?? '';
    const text3 = s.ps.custom_text_3 ?? '';

    return (
        <div className="gray-box">
            <div>
                <div>
                    <div>
                        {s.prod.CustomField1_Enabled && (
                            <div>
                                <label
                                    htmlFor="custom-field-1"
                                    className="b"
                                >
                                    {s.prod.CustomField1_Title}
                                </label>
                                <div>
                                    <input
                                        id="custom-field-1"
                                        type="text"
                                        className="form-control"
                                        style={{width: 250}}
                                        value={text1}
                                        onChange={save1}
                                        maxLength={max1}
                                        aria-label={`Enter ${s.prod.CustomField1_Title}`}
                                        aria-describedby="custom-field-1-remaining"
                                    />
                                    <span
                                        id="custom-field-1-remaining"
                                        className="form-text text-muted"
                                    >
                                        {remainingCharactersLabel(text1, max1)}
                                    </span>
                                </div>
                            </div>
                        )}
                        {s.prod.CustomField2_Enabled && (
                            <div className="mt-2">
                                <label
                                    htmlFor="custom-field-2"
                                    className="b"
                                >
                                    {s.prod.CustomField2_Title}
                                </label>
                                <input
                                    id="custom-field-2"
                                    type="text"
                                    className="form-control"
                                    style={{width: 250}}
                                    value={text2}
                                    onChange={save2}
                                    maxLength={max2}
                                    aria-label={`Enter ${s.prod.CustomField2_Title}`}
                                    aria-describedby="custom-field-2-remaining"
                                />
                                <span
                                    id="custom-field-2-remaining"
                                    className="form-text text-muted"
                                >
                                    {remainingCharactersLabel(text2, max2)}
                                </span>
                            </div>
                        )}
                        {s.prod.CustomField3_Enabled && (
                            <div className="mt-2 mb-2">
                                <label
                                    htmlFor="custom-field-3"
                                    className="b"
                                >
                                    {s.prod.CustomField3_Title}
                                </label>
                                <input
                                    id="custom-field-3"
                                    type="text"
                                    className="form-control"
                                    style={{width: 250}}
                                    value={text3}
                                    onChange={save3}
                                    maxLength={max3}
                                    aria-label={`Enter ${s.prod.CustomField3_Title}`}
                                    aria-describedby="custom-field-3-remaining"
                                />
                                <span
                                    id="custom-field-3-remaining"
                                    className="form-text text-muted"
                                >
                                    {remainingCharactersLabel(text3, max3)}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default CustomFieldsComponent;
